import { combineReducers } from 'redux';
import shareReducer from '../shared_elements/reducers';
import CSPReducer from '../applications/CspPortal/CSP-Form/reducers';

const rootReducer = combineReducers({
  shareReducer,
  CSPReducer,
});
export default rootReducer;
